import { ModelSagres } from "../../model-sagres"

/**
 * Este modelo é utilizado na página onde uma prestação LRFCI é preenchida e enviada para a API. 
 * Data a natureza como estas prestações foram modeladas em nosso BD, esta entidade difere da entidade que 
 * exibe uma LRFCI já cadastrada.
 * 
 * @since 20220728
 */
export class EntregaPrestacaoDeContasLRFCI extends ModelSagres {
    ano: number
    tipo: number
    periodo: number
    arquivoPDF: File

    constructor() {
        super()
        this.ano = 0
        this.tipo = 0
        this.periodo = 0
    }
}